import { useEffect } from 'react';

import { OAUTH_RETURN_PARAM, publishOAuthReturn } from '../logic/oauth-return-channel';

/**
 * Runs in the tab the platform redirected back to: tells the waiting tab the flow
 * finished, drops the marker from the URL, and closes itself (self-close works on
 * a script-opened tab even after COOP cut the opener link).
 */
export function useOAuthReturn(): void {
  useEffect(() => {
    const url = new URL(window.location.href);
    const platform = url.searchParams.get(OAUTH_RETURN_PARAM);
    if (!platform) return;

    publishOAuthReturn(platform);

    url.searchParams.delete(OAUTH_RETURN_PARAM);
    window.history.replaceState(null, '', url.toString());
    window.close();
  }, []);
}
